import Component from '@glimmer/component';

export default class PeopleMultiAvatarPreviewIndexComponent extends Component {
  get people() {
    if (this.args.people?.promise) return this.args.people.content;
    return this.args.people;
  }

  get firstPerson() {
    return this.people[0];
  }

  get restPeople() {
    return this.people.slice(1).map((person) => person.name);
  }
}
